import 'core-js/modules/es.string.includes.js';
import { __awaiter } from '../../_virtual/_tslib.js';
import { GetPdfPages } from './get-pdf-pages.js';
import { GetVideoDuration } from './get-video-duration.js';

class UpdateAssetDuration {
  execute(assetId, assetFile) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!assetId || !assetFile) return;
      const isCustomDurationFileType = assetFile.type.includes('video') || assetFile.type.includes('image') || assetFile.type.includes('pdf');
      if (!isCustomDurationFileType) {
        return {
          name: assetFile.name,
          assetId,
          metadata: {
            size: assetFile.size || 0
          }
        };
      }
      const metadataAsset = {
        size: assetFile.size || 0
      };
      if (assetFile.type.includes('video')) {
        metadataAsset.duration = yield new GetVideoDuration().execute(assetFile);
      }
      if (assetFile.type.includes('pdf')) {
        metadataAsset.pages = yield new GetPdfPages().execute(assetFile);
      }
      return {
        name: assetFile.name,
        assetId,
        metadata: metadataAsset
      };
    });
  }
}

export { UpdateAssetDuration };
